import React from "react";
import { useMemo } from "react";
import { CSVLink } from "react-csv";
import { transformToCSVData } from "../../utils/csvUtils";
import { Download } from "@mui/icons-material";
import { IconButton } from "@mui/material";

type CsvLinkButtonProps = {
  disabled?: boolean;
  data: object[];
  fileName: string;
  includeHeaders?: boolean;
};

/**
 * Renders the CSV link button to export the given data as a csv file
 * @param disabled Whether the button should be clickable or not
 * @param data The data to export
 * @param fileName The name of the file to export
 * @param includeHeaders Whether to include a header row in the CSV (default true)
 *
 */
const CsvLinkButton = ({ disabled = false, data, fileName, includeHeaders = true }: CsvLinkButtonProps) => {
  const csvData = useMemo(() => transformToCSVData(data), [data]);

  return disabled || data.length === 0 ? (
    <IconButton disabled>
      <Download />
    </IconButton>
  ) : (
    <CSVLink
      headers={includeHeaders ? csvData.headers : []}
      data={csvData.data}
      filename={`${fileName}.csv`}
      separator=";"
    >
      <IconButton>
        <Download />
      </IconButton>
    </CSVLink>
  );
};

export default CsvLinkButton;
